import { memo, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

import { workspaceAgentConsentDockTitle } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentComposerChrome';

export type WorkspaceAgentDockFrameProps = {
  bodyId?: string;
  children?: ReactNode;
  /** Set when this region must be keyboard-scrollable. Omit it inside a popover so focus stays on the field. */
  tabIndex?: number;
  /** Plain text, or chips when a private ask quotes a moniker. */
  title?: ReactNode;
  titleId?: string;
};

export const WorkspaceAgentDockFrame = memo(
  ({ bodyId, children, tabIndex, title, titleId }: WorkspaceAgentDockFrameProps) => {
    const hasTitle = title != null && title !== '';

    if (!hasTitle && children == null) {
      return null;
    }

    return (
      <div
        className={cn('min-h-0 overflow-y-auto', hasTitle && 'flex-1')}
        tabIndex={tabIndex} // NOSONAR -- scrollable region must be focusable for keyboard scrolling when requested
      >
        {hasTitle ? (
          <div className="p-4">
            <h2 className={workspaceAgentConsentDockTitle()} id={titleId}>
              {title}
            </h2>
          </div>
        ) : null}
        {children != null ? (
          <div className={cn('px-4 pb-4', !hasTitle && 'pt-4')} id={bodyId}>
            {children}
          </div>
        ) : null}
      </div>
    );
  },
);

WorkspaceAgentDockFrame.displayName = 'WorkspaceAgentDockFrame';
